"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EForumPostCategory = void 0;
const enum_1 = require("../../../../utils/enum");
exports.EForumPostCategory = (0, enum_1.strEnum)(["GENERAL", "CASTING"]);
